
import { Helmet } from 'react-helmet-async';

// Use the production canonical URL (HTTPS) as the site root
const SITE_URL = 'https://fusiontechuae.com';

const Seo = ({
  title = 'Fusion Tech — Electromechanical Systems Supply and Installation in Dubai',
  description = 'Fusion Tech — modern industrial automation, SCADA, PLCs, instrumentation and electromechanical solutions.',
  image = `${SITE_URL}/fusion-social.png`,
  url = '',
  keywords = 'SCADA Solutions in Dubai, UAE, Telemetry Solutions in Dubai UAE, Industrial Automation Dubai UAE, Electrical Spare Parts in Dubai UAE, Automation Spare Parts Dubai UAE, PLC, RTU, DCS from Dubai, Control Panels from Dubai, Machine Supply from Dubai, Electromechanical Systems Supply and Installation in Dubai',
  jsonLd = null,
  noindex = false,
}) => {
  // Ensure og:image is absolute
  const absoluteImage = image && image.startsWith && image.startsWith('http') ? image : `${SITE_URL}${image && image.startsWith('/') ? '' : '/'}${image || 'fusion-social.png'}`;

  // Default JSON-LD (Organization + WebSite) for better rich results
  const defaultJsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${SITE_URL}/#organization`,
        "name": "Fusion Tech General Trading FZCO",
        "url": SITE_URL,
        "logo": absoluteImage,
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "telephone": "+971522340058",
            "contactType": "customer service",
            "areaServed": "AE",
            "availableLanguage": ["English"]
          }
        ],
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "IFZA Business Park Building A1",
          "addressLocality": "Dubai Silicon Oasis",
          "addressRegion": "Dubai",
          "postalCode": "",
          "addressCountry": "UAE"
        }
      },
      {
        "@type": "WebSite",
        "@id": `${SITE_URL}/#website`,
        "url": SITE_URL,
        "name": title,
        "description": description,
        "publisher": { "@id": `${SITE_URL}/#organization` }
      }
      ,
      {
        "@type": "LocalBusiness",
        "@id": `${SITE_URL}/#localbusiness`,
        "name": "Fusion Tech General Trading FZCO",
        "description": description,
        "url": SITE_URL,
        "telephone": "+971522340058",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "IFZA Business Park Building A1",
          "addressLocality": "Dubai",
          "addressRegion": "Dubai",
          "postalCode": "",
          "addressCountry": "AE"
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday"
            ],
            "opens": "09:00",
            "closes": "18:00"
          }
        ],
        "sameAs": [
          "https://www.linkedin.com/company/fusiontech"
        ]
      }
    ]
  };

  const currentPath = (typeof window !== 'undefined' && window.location && window.location.pathname)
    ? window.location.pathname
    : '/';

  const canonicalUrl = url
    ? (url.startsWith('http') ? url : `${SITE_URL}${url.startsWith('/') ? '' : '/'}${url}`)
    : `${SITE_URL}${currentPath}`;

  const normalizeCanonical = (value) => {
    if (!value || typeof value !== 'string') return value;

    // Ensure root canonical is always SITE_URL + '/'
    if (value === SITE_URL || value === `${SITE_URL}/`) return `${SITE_URL}/`;

    // Production server canonicalizes to trailing-slash URLs (301 -> /path/).
    // Match that exactly to avoid canonical vs redirect mismatches.
    return value.endsWith('/') ? value : `${value}/`;
  };

  const canonicalUrlNormalized = normalizeCanonical(canonicalUrl);

  // Merge provided jsonLd with defaults: if jsonLd prop exists use it, otherwise use defaultJsonLd
  const jsonLdToRender = jsonLd || defaultJsonLd;

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex,follow" />}

      {/* Canonical and Open Graph URLs */}
      <link rel="canonical" href={canonicalUrlNormalized} />
      <meta property="og:url" content={canonicalUrlNormalized} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={absoluteImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Fusion Tech" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absoluteImage} />

      {/* JSON-LD structured data */}
      {jsonLdToRender && (
        <script type="application/ld+json" data-seo="true">
          {JSON.stringify(jsonLdToRender)}
        </script>
      )}
    </Helmet>
  );
};

export default Seo;
